import * as actionTypes from './actionTypes';

export const printerAddEquip = (equip) => {
  return {
    type: actionTypes.PRINTER_ADD_EQUIP,
    equip
  }
}

export const printerClearEquip = () => {
  return {
    type: actionTypes.PRINTER_CLEAR_EQUIP
  }
}